import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'

import Step from '../../../../../../../../../features/components/Forms/StepForm/Step'
import RightInventoryTable from './RightInventoryTable'
import InventoryOverviewSpoiler from '../../../../../components/InventoryOverviewSpoiler'

import { rightSelector } from '../../../../../../../../../modules/selectors/rights'

import { useUnitTypeLabel } from '../../../../hooks/remainingBudgetHooks'
import { getIsBudgetAllocationType } from '../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'
import { getGamInventoryType, inventoryTypes } from '../../../../helpers'

import { AD_INVENTORY } from '../../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

import useDrawerFormStyles from '../../../../../../../../../styles/common/drawerForms'

const SubAllocationInventoryTargetingStep = ({ formik }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormStyles()

  const right = useSelector(rightSelector)

  const unitTypeLabel = useUnitTypeLabel()
  const isBudgetAllocationType = getIsBudgetAllocationType(right)
  const inventoryType = getGamInventoryType(right[AD_INVENTORY])

  const title = useMemo(() => {
    return isBudgetAllocationType
      ? t('What budget do you want to set for each piece of ad inventory?')
      : t(`What ${unitTypeLabel} budget do you want to set for each piece of ad inventory?`)
  }, [t, isBudgetAllocationType, unitTypeLabel])

  const inventoryTypeName = useMemo(() => {
    return inventoryType === inventoryTypes.placements ? 'placement' : 'ad unit'
  }, [inventoryType])

  return (
    <Step stepTitle={title}>
      <InventoryOverviewSpoiler />
      <section className={drawerFormClasses.section}>
        <h4 className={drawerFormClasses.sectionTitle}>{t('Budget')}</h4>
        {isBudgetAllocationType ? (
          <p>{t(`Enter budget for each target ${inventoryTypeName}`)}</p>
        ) : (
          <p>{t(`Enter an ${unitTypeLabel} budget for each target ${inventoryTypeName}`)}</p>
        )}

        <RightInventoryTable formik={formik} />
      </section>
    </Step>
  )
}

export default SubAllocationInventoryTargetingStep
